import { ActionTypes } from "./action-types";

const initialState = {
  loading: false,
  sent: false
};

function ForgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        sent: false
      };
    case ActionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        sent: true
      };
    case ActionTypes.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        sent: false
      };

    case ActionTypes.FORGOT_PASSWORD_CLEAN_UP:
      return {
        ...state,
        loading: false,
        sent: false
      };
    default:
      return state;
  }
}

export default ForgotPasswordReducer;
